import { call, delay, put, select, spawn, takeEvery, takeLatest } from 'redux-saga/effects';

import { auth$refresh } from '@/api/auth';
import { get$user$name } from '@/api/user-cabinet';
import { AuthResponse } from '@/types/auth';
import { User } from '@/types/user-cabinet';
import { storageKeys } from '@/utils/constants';
import { Cookies } from '@/utils/cookies';

import { AuthActionTypes, isLoggedInSet, userNameLoad, userNameSet } from './auth.actions';
import { selectIsLoggedIn } from './auth.selectors';

function* initialAuthRefresh() {
    const token: AuthResponse = yield call(auth$refresh);
    if (!token) return;
    Cookies.set(storageKeys.accessToken, token.access_token, { path: '/', 'Max-Age': token.expires });
    yield put(isLoggedInSet(true));
}

function* intervalAuthRefresh() {
    const isLoggedIn: ReturnType<typeof selectIsLoggedIn> = yield select(selectIsLoggedIn);

    while (isLoggedIn) {
        const token: AuthResponse = yield call(auth$refresh);
        yield put(userNameLoad(token.access_token));
        yield delay(
            token.expires - 60_000,
            Cookies.set(storageKeys.accessToken, token.access_token, { path: '/', 'Max-Age': token.expires }),
        );
    }
}

function* authRefreshSaga() {
    yield takeLatest(AuthActionTypes.isLoggedInSet, intervalAuthRefresh);
}

function* username$load(action: ReturnType<typeof userNameLoad>) {
    const user: Pick<User, 'first_name'> = yield call(get$user$name, action.payload);
    yield put(userNameSet(user.first_name));
}

function* userNameLoadSaga() {
    yield takeEvery(AuthActionTypes.userNameLoad, username$load);
}

export function* authEffects() {
    yield spawn(initialAuthRefresh);
    yield spawn(authRefreshSaga);
    yield spawn(userNameLoadSaga);
}
